import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { IcoHome, IcoTravel, IcoUser } from "assets/icons";

import styles from "./styles.module.scss";

export default function ProviderLayout() {
	const location = useLocation();
	const navigate = useNavigate();

	const getHeaderTitle = () => {
		const path = location.pathname;
		if (path.startsWith("/dashboard/cadastro/")) return "Cadastro";
		if (path.startsWith("/dashboard/mensagens")) return "Mensagens";
		return "Dashboard";
	};

	const isActive = (route: string) => {
		return location.pathname.startsWith(route);
	};

	return (
		<div className={styles.container}>
			<main>
				<Outlet />
			</main>

			<nav className={styles.navbar}>
				<button
					onClick={() => {
						navigate("/home");
					}}
					className={isActive("/home") ? styles.active : styles.inactive}
				>
					<IcoHome color={isActive("/home") ? "#FD6C05" : "#6B7280"} />
					<span>Início</span>
				</button>
				<button
					onClick={() => {
						navigate("/viagens");
					}}
					className={isActive("/viagens") ? styles.active : styles.inactive}
				>
					<IcoTravel color={isActive("/viagens") ? "#FD6C05" : "#6B7280"} />
					<span>Viagens</span>
				</button>
				{/*
				<button
					onClick={() => {
						navigate("/extrato");
					}}
					className={isActive("/extrato") ? styles.active : styles.inactive}
				>
					<IcoExtract color={isActive("/extrato") ? "#FD6C05" : "#6B7280"} />
					<span>Extrato</span>
				</button>
				*/}
				<button
					onClick={() => {
						navigate("/perfil");
					}}
					className={isActive("/perfil") ? styles.active : styles.inactive}
				>
					<IcoUser color={isActive("/perfil") ? "#FD6C05" : "#6B7280"} />
					<span>Perfil</span>
				</button>
			</nav>
		</div>
	);
}
